import { get, useFormContext } from "react-hook-form";

export const findAllByKey = (obj: Object, keyToFind: string): any[] => {
    return Object.entries(obj)
        .reduce((acc: any[], [key, value]) => (key === keyToFind && value)
            ? acc.concat(value)
            : (typeof value === 'object')
                ? acc.concat(findAllByKey(value, keyToFind))
                : acc
            , [])
};

export const findAllByKeyValue = (obj: Object, keyToFind: string, valueToFind: any): any[] => {
    return Object.entries(obj)
        .reduce((acc: any[], [key, value]) => (key === keyToFind && value == valueToFind)
            ? acc.concat(obj)
            : (typeof value === 'object')
                ? acc.concat(findAllByKeyValue(value, keyToFind, valueToFind))
                : acc
            , [])
};

export const useFieldFormContext = () => {
    const { register, formState: { errors } } = useFormContext();

    const isInvalid = (name: string) => {
        const error = get(errors, name);
        return error ? true : false;
    }

    return {
        register: register,
        registerField: (field: { id: string, name: string, options?: any }) => {
            return {
                ...register(field.name, field?.options),
                id: field.id,
                "aria-invalid": isInvalid(field.name),
                "maxLength": field?.options?.maxLength,
                "minLength": field?.options?.minLength,
                "disabled": field?.options?.disabled,
                "title": field?.options?.title,
                "readOnly": field?.options?.readOnly,
            }
        }
    }
}